import { render, staticRenderFns } from "./AuthenticationLayout.vue?vue&type=template&id=31138177&scoped=true&"
import script from "./AuthenticationLayout.vue?vue&type=script&lang=ts&"
export * from "./AuthenticationLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticationLayout.vue?vue&type=style&index=0&id=31138177&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31138177",
  null
  
)

export default component.exports